import { HlmAlertDialogModule } from '@/app/components/ui/ui-alertdialog-helm/src';
import { Component, computed } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import {
  trigger,
  transition,
  style,
  animate,
} from '@angular/animations';

export type AlertButtons = {
  id: string,
  action: () => void | null | undefined;
  text: string;
  type: 'action' | 'cancel'; // action: blue, cancel: white
};

@Component({
  selector: 'cp-alert',
  standalone: true,
  imports: [HlmAlertDialogModule, NgIcon],
    animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('250ms ease-out', style({ opacity: 1, transform: 'scale(1)' })),
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'scale(0.95)' })),
      ]),
    ]),
  ],
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <hlm-alert-dialog [@fadeIn] class="bg-white rounded-xl shadow-xl inline-block max-w-md w-full">
        <hlm-alert-dialog-content>
          <hlm-alert-dialog-header>
            <div class="flex flex-row justify-between">
              <h3 hlmAlertDialogTitle class="text-blue-500">{{ data.header }}</h3>
              @if (data.isXIconVisible) {
                <button id='btn-alert-x' hlmBtn variant="ghost" size="icon" class="cursor-pointer btn-alert-x" (click)="cancel()">
                  <ng-icon name="phosphorX" size="18" />
                </button>
              }
            </div>
            <p hlmAlertDialogDescription class="whitespace-pre-line">
              {{ description() }}
            </p>
          </hlm-alert-dialog-header>
          <hlm-alert-dialog-footer>
            @for (button of data.buttons; track button.text) {
              @if (button.type === 'cancel') {
                <button [id]="button.id" [class]="'cursor-pointer ' + button.id" hlmAlertDialogCancel (click)="button.action()">{{ button.text }}</button>
              } @else {
                <button [id]="button.id" [class]="'cursor-pointer ' + button.id" hlmAlertDialogAction (click)="button.action()">{{ button.text }}</button>
              }
            }
          </hlm-alert-dialog-footer>
        </hlm-alert-dialog-content>
      </hlm-alert-dialog>
    </div>
  `,
})
export class AlertComponent {
  private dialogRef = injectBrnDialogContext();
  public data: any = this.dialogRef.data;

  description = computed(() => this.data.description());
  
  cancel(): void {
    const cancelActionButton = this.data.buttons.find((button: AlertButtons) => button.type === 'cancel');
    cancelActionButton.action();
  }
}


